import LocalizedStrings from 'localized-strings';

import { PackageType } from '__generated__/GQL';

const locales = new LocalizedStrings({
  en: {
    claims: {
      bankAccountIncludedFor: 'Bank account included for {0} months',
      discounted: 'instead of {basePrice} {taxMention}',
      pricePlan: 'Then {price} / month {taxMention}',
    },

    continue: 'Go to payment',

    packageTypes: {
      [PackageType.CapitalDeposit]: 'Capital Deposit',
      [PackageType.ShineStart]: 'Creation of a micro-enterprise',
    },

    planDescription: '{months} months of Shine {brandName}',

    plans: {
      [PackageType.CapitalDeposit]: {
        title: 'Capital Deposit {brandName}',
      },
      [PackageType.ShineStart]: {
        title: 'Creation of a micro-enterprise {brandName}',
      },
    },

    title: 'Confirm your choice',

    vat: {
      excluded: 'excl. tax',
      included: 'incl. tax',
    },
  },

  fr: {
    claims: {
      bankAccountIncludedFor: '{0} mois de compte pro inclus',
      discounted: 'au lieu de {basePrice} {taxMention}',
      pricePlan: 'Puis {price} / mois {taxMention}',
    },

    continue: 'Passer au paiement',

    packageTypes: {
      [PackageType.CapitalDeposit]: 'Dépôt de capital',
      [PackageType.ShineStart]: 'Création micro entreprise',
    },

    planDescription: '{months} mois de compte pro Shine {brandName}',

    plans: {
      [PackageType.CapitalDeposit]: {
        title: 'Offre dépôt de capital {brandName}',
      },
      [PackageType.ShineStart]: {
        title: 'Offre création micro entreprise {brandName}',
      },
    },

    title: 'Confirmez votre choix',

    vat: {
      excluded: 'HT',
      included: 'TTC',
    },
  },
} as const);

export default locales;
